var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"feature-remove-image",attrs:{"type":"button","title":"حذف عکس"},on:{"click":function($event){$event.stopPropagation();return _vm.removeFeatureImage()}}},[_c('b-icon-trash')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }